import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { useCheckoutHref } from '../../hooks/useCheckoutHref';
import { OFFER_ANCHOR } from '../../data/site';
type CtaButtonProps = {
  /** "offer" scrolls to #offer-details; "checkout" goes to the real store checkout. */
  target: 'offer' | 'checkout';
  children: React.ReactNode;
  size?: 'lg' | 'xl';
  className?: string;
};
const sizes = {
  lg: 'min-h-[64px] px-6 text-[22px] sm:px-8 sm:text-[26px]',
  xl: 'min-h-[72px] px-5 text-[24px] sm:px-8 sm:text-[30px]'
};
export function CtaButton({
  target,
  children,
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const checkoutHref = useCheckoutHref();
  const href = target === 'offer' ? OFFER_ANCHOR : checkoutHref;
  return <a href={href} className={`group inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-[14px] bg-go font-display font-bold uppercase leading-none tracking-wide text-white shadow-[0_6px_0_#9B340C] transition-[background-color,transform,box-shadow] duration-150 ease-out [text-shadow:0_1px_2px_rgba(0,0,0,0.35)] hover:bg-go-hover active:translate-y-[4px] active:shadow-[0_2px_0_#9B340C] ${sizes[size]} ${className}`} data-id="element-289" data-mp="1h6uslqjr3avx">
      {children}
      <ArrowRightIcon aria-hidden="true" strokeWidth={3} className="hidden h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1 min-[360px]:block" data-id="element-290" data-mp="2qggc4egbn2ob" />
    </a>;
}